export default "/images/vendor/flag-icon-css/flags/1x1/sj.svg?bf11a7596686324ffe17b844d8d2da49";